import { observer } from 'mobx-react-lite';

import { useActiveSpaceHandlerPresenter } from './ActiveSpaceHandler.presenter';

export const ActiveSpaceHandler = observer(() => {
  useActiveSpaceHandlerPresenter();
  return null;
});
